import { render, staticRenderFns } from "./ResellerDashboard.vue?vue&type=template&id=2d4d29be&"
import script from "./ResellerDashboard.vue?vue&type=script&lang=js&"
export * from "./ResellerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports